import { render } from "./ImportTasks.vue?vue&type=template&id=bcd8d56a&scoped=true"
import script from "./ImportTasks.vue?vue&type=script&lang=js"
export * from "./ImportTasks.vue?vue&type=script&lang=js"

import "./ImportTasks.vue?vue&type=style&index=0&id=bcd8d56a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd8d56a"]])

export default __exports__